
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/accessible",
      function () {
        return require("private-next-pages/accessible.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/accessible"])
      });
    }
  